<script>
// import displaySettings from "@/mixin/displaySettings";
// import displaySettings from "@/utils/display-settings"
import DisplaySetting from "@/utils/display-settings";
import { applyUpdateAndReload } from "@/utils/sw-update";
import Vue from 'vue'

Vue.use(DisplaySetting);

export default {
    name: "UpdateApp",
    // mixins: [displaySettings],
    data() {
        return {
            dialogVisible: true,
            updating: false
        }
    },
    methods: {
        show() {
            this.dialogVisible = true
        },
        async updatePage() {
            if (this.updating) return
            this.updating = true
            // Активує новий service worker і перезавантажує сторінку зі свіжими ассетами.
            await applyUpdateAndReload()
        }
    }
}
</script>

<template>
    <div>
        <!--    :before-close="handleClose"-->
        <el-dialog
            center
            title="Нова версія додатку"
            :visible.sync="dialogVisible"
            :width="$isMobile ? '100%': '30%'"
        >
            <span>Для коректної роботи оновіть сторінку</span>
            <span slot="footer" class="dialog-footer">
                <el-button :disabled="updating" @click="dialogVisible = false">Відминити</el-button>
                <el-button type="primary" :loading="updating" @click="updatePage">Оновити сторінку</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<style scoped>
* >>> .el-dialog__body {
    text-align: center;
}
</style>
